export default __webpack_public_path__ + "static/media/Mixed_Media-small.86d32cbd.jpeg";